<template>
  <div class="Cooperative_organization">
    <div class="main">
      <p class="title">合作机构</p>

      <div class="swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide"><img :src="img1"/></div>
            <div class="swiper-slide"><img :src="img2"/></div>
            <div class="swiper-slide"><img :src="img3"/></div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
        </div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev swiper_btn"></div>
        <div class="swiper-button-next swiper_btn"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import Swiper from 'swiper/dist/js/swiper.js'
  export default {
    name: 'CooperativeOrganization',
    data() {
      return {
        img1: require("@/assets/imgs/co-operate-01.png"),
        img2: require("@/assets/imgs/co-operate-02.png"),
        img3: require("@/assets/imgs/co-operate-03.png")
      }
    },
    mounted() {
      var mySwiper = new Swiper('.Cooperative_organization .swiper-container', {
        autoplay: true,
        loop: true,
        speed: 1000,

        // // 如果需要分页器
        // pagination: {
        //   el: '.swiper-pagination'
        // },

        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .Cooperative_organization {
    background: rgba(244, 244, 244, 1);
    padding-bottom: 80px;
    width: 100%;
    display: inline-block;

    .main {
      width: 1200px;
      margin: 0 auto;

      .title {
        height: 50px;
        font-size: 40px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        text-align: center;
        margin: 58px 0 80px;
      }

      .swiper {
        width: 1200px;
        position:relative;

        .swiper-container {
          width: 960px;
          height: 370px;
          box-sizing: border-box;
          margin: 0 120px;

          img {
            width: 100%;
          }
        }

        .swiper_btn{
          width: 45px;
          height: 92px;
          background-size: contain;
          outline: none;
          top: 30%;
          padding: 5px 15px;
        }
        .swiper-button-prev {
          background: url("../../assets/imgs/arrow-left.png") no-repeat center;
          background-size: 35px 70px;
          &:hover {
            background-position: 20%;
            background-size: 45px 92px;
          }
        }
        .swiper-button-next {
          background: url("../../assets/imgs/arrow-right.png") no-repeat center;
          background-size: 35px 70px;
          &:hover {
            background-position: 80%;
            background-size: 45px 92px;
          }
        }


        .swiper-pagination {
          position: absolute;
          z-index: 20;
          bottom: 10px;
          width: 100%;
          text-align: center;
        }
        .swiper-pagination-switch {
          display: inline-block;
          width: 20px;
          height: 20px;
          border-radius: 8px;
          background: #555;
          margin: 0 5px;
          opacity: 0.8;
          border: 1px solid #fff;
          cursor: pointer;
        }
        .swiper-active-switch {
          background: #fff;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/CooperativeOrganization.vue